import { FIELDS } from 'modules/cm/fields/types';
import { nullableNumber, nullableString } from 'utils/form/validation';
import * as yup from 'yup';
import { Property, PropertyOccupant } from './Property.types';
import { dateValidation } from 'utils/date';

export default yup.object().shape<Property>({
  [FIELDS.PROPERTY_FLAT_NUMBER]: nullableString(),
  [FIELDS.PROPERTY_BUILDING_NAME]: nullableString(),
  [FIELDS.PROPERTY_BUILDING_NUMBER]: nullableString(),
  [FIELDS.PROPERTY_STREET]: nullableString(),
  [FIELDS.PROPERTY_CITY]: nullableString(),
  [FIELDS.PROPERTY_POSTCODE]: nullableString(),
  [FIELDS.PROPERTY_HAS_OCCUPANTS_OVER17]: nullableString(),
  [FIELDS.PROPERTY_TYPE]: nullableString(),
  [FIELDS.PROPERTY_IS_PRIMARY_HOME]: nullableString(),
  [FIELDS.PROPERTY_FLOOR_NUMBER]: nullableNumber(),
  [FIELDS.PROPERTY_NUMBER_OF_FLOORS_IN_THE_BUILDING]: nullableNumber(),
  [FIELDS.PROPERTY_HAS_LIFT_ACCESS]: nullableString(),
  [FIELDS.PROPERTY_TENURE_TYPE]: nullableString(),
  [FIELDS.PROPERTY_REMAINING_YEARS]: nullableNumber(),
  [FIELDS.PROPERTY_IS_EX_LOCAL_AUTHORITY]: yup.boolean().nullable(),
  [FIELDS.PROPERTY_IS_RETIREMENT_HOME]: yup.boolean().nullable(),
  [FIELDS.PROPERTY_IS_RESTRICTED_COVENANT]: yup.boolean().nullable(),
  [FIELDS.PROPERTY_IS_ABOVE_COMMERCIAL_PREMISES]: yup.boolean().nullable(),
  [FIELDS.PROPERTY_COMMERCIAL_PREMISES_DETAILS]: nullableString(),
  [FIELDS.PROPERTY_HAS_COMMERCIAL_USAGE_ABOVE25_PERCENT]: nullableString(),
  [FIELDS.PROPERTY_COMMERCIAL_USAGE_DETAILS]: nullableString(),
  [FIELDS.PROPERTY_NUMBER_OF_KITCHENS]: nullableNumber(),
  [FIELDS.PROPERTY_NUMBER_OF_BEDROOMS]: nullableNumber(),
  [FIELDS.PROPERTY_HAS_AGRICULTURAL_RESTRICTIONS]: nullableString(),
  [FIELDS.PROPERTY_PROPERTY_YEAR_BUILT]: nullableNumber(),
  [FIELDS.PROPERTY_WARRANTY_PROVIDER]: nullableString(),
  [FIELDS.PROPERTY_IS_PROPERTY_NEW_BUILD]: nullableString(),
  [FIELDS.PROPERTY_PROPERTY_CONSTRUCTION]: nullableString(),
  [FIELDS.PROPERTY_PROPERTY_DETAILS]: nullableString(),
  [FIELDS.PROPERTY_INSTRUCTION_DATE]: dateValidation().nullable(),
  [FIELDS.PROPERTY_INSPECTION_DATE]: dateValidation().nullable(),
  [FIELDS.PROPERTY_VALUATION_TYPE]: nullableString(),
  [FIELDS.PROPERTY_HAS_SPECIALIST_REPORT]: nullableString(),
  [FIELDS.PROPERTY_TITLE_NUMBER]: nullableString(),
  [FIELDS.PROPERTY_ESTIMATED_PROPERTY_VALUE]: nullableNumber(),
  [FIELDS.PROPERTY_PROPERTY_PURCHASE_PRICE]: nullableNumber(),
  [FIELDS.PROPERTY_ACTUAL_PROPERTY_VALUE]: nullableNumber(),
  [FIELDS.PROPERTY_OCCUPANTS_PREFIX]: yup.array().of<PropertyOccupant>(
    yup.object().shape({
      id: yup.number(),
      [FIELDS.PROPERTY_OCCUPANT_FULLNAME]: nullableString(),
      [FIELDS.PROPERTY_OCCUPANT_DATE_OF_BIRTH]: dateValidation().nullable(),
    }),
  ),
});
